import React from "react";
//#region types
import { WintSuperkollAPIModel as ApiModels, WintUtilsWebApi } from "wint-api-client/dist/types";
import { TranslationKeys } from "translations";
import { DocumentFormTypes } from "models/formTypes";
import { TableRowCommonKeys, TableRowProperties } from "models/propTypes/simpleTableProps";
import { GenericDocumentsListProps } from "models/propTypes/documentPropTypes";
//#endregion
//#region components
import { TableAsync, useFilterContext, useSearchContext } from "components/common";
import GenericDocumentStatusTags from "./statusTags";
import { useNavigate, useLocation } from "react-router-dom";
import { useGenericDocumentService } from "serviceHooks";
//#endregion
import { UrlHelper } from "utils/helpers";

const GenericDocumentsList: React.FC<GenericDocumentsListProps> = (props) => {
  const genericDocumentService = useGenericDocumentService();
  const { filter } = useFilterContext<DocumentFormTypes.GenericDocumentFilter>();
  const searchContext = useSearchContext();
  const location = useLocation();
  const navigate = useNavigate();

  const filterFunc = React.useCallback(
    (pagination: WintUtilsWebApi.Filter) =>
      genericDocumentService.getGenericDocuments(pagination, {
        ...(filter ?? {}),
        description: searchContext?.searchText,
      }),
    [filter, searchContext?.searchText]
  );

  const onRowClick = (row: ApiModels.GenericDocument) => {
    navigate(UrlHelper.formatPath(`/AccountingDocument/${row.id}`), {
      state: { background: location, preserveSearch: true },
    });
  };

  const tableProperties: Partial<
    Record<keyof TableRowCommonKeys | keyof ApiModels.GenericDocument, TableRowProperties>
  > = {
    description: {
      description: TranslationKeys.Common.Name,
      formatter: (r: ApiModels.GenericDocument) => r.description,
    },
    createdDate: {
      description: TranslationKeys.Common.Created,
      formatter: (r: ApiModels.GenericDocument) => new Date(r.createdDate),
    },
    state: {
      description: TranslationKeys.Common.Status,
      formatter: (r: ApiModels.GenericDocument) => <GenericDocumentStatusTags status={r.state} />,
    },
  };

  return (
    <TableAsync<ApiModels.GenericDocument>
      properties={tableProperties}
      filter={filterFunc}
      pagination={"advanced"}
      orderByProperty="createdDate"
      orderByDescending
      rowClickHandler={onRowClick}
      reloadKey={props.reloadKey}
    />
  );
};
export default GenericDocumentsList;
